import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 71 74"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "#0DD14F",
      d: "M35.5 13.66V0H4.64C1.94 0-.22 3 .02 6.48v.04c.46 6.2 2.17 14.98 4.91 21.31.77 1.79 1.6 2.86 4.13 2.92 1.74.04 16.26-.02 16.26-.02a3.95 3.95 0 0 1 3.96 3.95v2.6a3.96 3.96 0 0 1-3.96 3.95H23.7a3.96 3.96 0 0 1-3.96-3.96v-.9H9.01c3.87 6.78 9.02 12.57 15.57 15.68H35.5V19.22a49 49 0 0 0-3.46.05H14.03c-2.32 0-4.21-.24-4.21-4.82 0-3.85 1.84-4.68 4.2-4.68h9.68a3.14 3.14 0 0 1 2.97 3.13v.76z"
    }, null, -1),
    _createElementVNode("path", {
      fill: "#027DFF",
      d: "M35.5 13.66V0h30.86c2.7 0 4.86 3 4.62 6.48v.04c-.46 6.2-2.17 14.98-4.91 21.31-.77 1.79-1.6 2.86-4.13 2.92-1.74.04-16.26-.02-16.26-.02a3.95 3.95 0 0 0-3.96 3.95v2.6a3.96 3.96 0 0 0 3.96 3.95h1.62a3.96 3.96 0 0 0 3.96-3.96v-.9h10.72c-3.86 6.78-9.02 12.57-15.57 15.68H35.5V19.22c1.02-.03 2.16-.01 3.45.05h18.02c2.32 0 4.2-.24 4.2-4.82 0-3.85-1.84-4.68-4.2-4.68H47.3a3.14 3.14 0 0 0-2.98 3.13v.76zM24.58 52.05c-.6 6.5-5.13 14.44-8.24 21.95H35.5V52.05z"
    }, null, -1),
    _createElementVNode("path", {
      fill: "#0DD14F",
      d: "M46.41 52.05c.62 6.5 5.13 14.44 8.24 21.95H35.5V52.05h10.92"
    }, null, -1)
  ])))
}
export default { render: render }